// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.table-toolbar {
  position: sticky;
  top: var(--lb-topbar-h, 52px);
  z-index: 20;
  padding: 14px 24px;
  border-bottom: 1px solid var(--border);
  display: flex;
  align-items: center;
  gap: 12px;
  background: var(--bg-alt);
}

/* Search input — 320px is the *preferred* width (flex-basis), but it shrinks
   intrinsically when the toolbar is cramped (min-width:0), so the page never
   overflows sideways on narrow viewports. No fixed breakpoint. */
.table-toolbar__search {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  height: 28px;
  padding: 0 10px;
  border: 1px solid var(--border);
  border-radius: var(--radius-1);
  background: var(--bg);
  color: var(--text-muted);
  font-size: var(--fs-meta);
  flex: 0 1 320px;
  min-width: 0;
  font-family: var(--sans);
  cursor: text;
}

.table-toolbar__search-icon {
  font-family: var(--mono);
  font-size: var(--fs-ui);
  color: var(--text-muted);
  flex-shrink: 0;
}

.table-toolbar__search-input {
  flex: 1;
  border: 0;
  background: transparent;
  outline: none;
  font: inherit;
  color: var(--text);
  padding: 0;
  margin: 0;
  min-width: 0;
}
.table-toolbar__search-input::placeholder {
  color: var(--text-muted);
}
.table-toolbar__search-input::-webkit-search-cancel-button {
  appearance: none;
}

.table-toolbar__search--active:focus-within {
  border-color: var(--text-secondary);
}

.table-toolbar__search-placeholder {
  flex: 1;
  color: var(--text-muted);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.table-toolbar__search-kbd {
  font-family: var(--mono);
  font-size: var(--fs-micro);
  background: var(--bg-alt);
  border: 1px solid var(--border);
  border-radius: 2px;
  padding: 1px 4px;
  color: var(--text-secondary);
  flex-shrink: 0;
}

/* Filter chips */
.table-toolbar__chips {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
}

.table-toolbar__chip {
  height: 26px;
  padding: 0 10px;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  border: 1px solid var(--border);
  border-radius: var(--radius-1);
  font-size: var(--fs-meta);
  color: var(--text-secondary);
  background: var(--bg);
  cursor: pointer;
  font-family: var(--sans);
  transition:
    background 120ms ease,
    border-color 120ms ease,
    color 120ms ease;
}

.table-toolbar__chip:focus-visible {
  outline: none;
  box-shadow: var(--focus-ring);
}

.table-toolbar__chip--active {
  border-color: var(--signal);
  background: var(--signal-soft);
  color: var(--signal-deep);
}

.table-toolbar__chip-count {
  font-family: var(--mono);
  font-size: var(--fs-sm);
  color: var(--text-muted);
}

.table-toolbar__chip--active .table-toolbar__chip-count {
  color: var(--signal-deep);
}

/* Spacer */
.table-toolbar__spacer {
  flex: 1;
}

/* Right-side control cluster — the sort + filter buttons sit together. */
.table-toolbar__controls {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

/* Inline filter select (e.g. court filter on the tribunals directory) */
.table-toolbar__select {
  height: 32px;
  padding: 0 10px;
  border: 1px solid var(--border);
  border-radius: var(--radius-0);
  background: var(--surface);
  color: var(--text);
  font-family: var(--mono);
  font-size: var(--fs-meta);
  cursor: pointer;
}

.table-toolbar__select:focus-visible {
  outline: 2px solid var(--signal-deep);
  outline-offset: 1px;
}

/* Density toggle */
.density-toggle {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.density-toggle__label {
  font-family: var(--mono);
  font-size: var(--fs-micro);
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: var(--text-muted);
}

.density-toggle__buttons {
  display: inline-flex;
  border: 1px solid var(--border);
  border-radius: var(--radius-1);
  overflow: hidden;
}

.density-toggle__btn {
  padding: 4px 10px;
  background: var(--bg);
  border: 0;
  border-right: 1px solid var(--border);
  font-family: var(--mono);
  font-size: var(--fs-micro);
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: var(--text-muted);
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 5px;
  transition:
    background 120ms ease,
    color 120ms ease;
}

.density-toggle__btn:last-child {
  border-right: 0;
}

.density-toggle__btn--active {
  background: var(--ink-dark);
  color: var(--cream);
}

.density-toggle__btn:focus-visible {
  outline: none;
  box-shadow: inset 0 0 0 2px var(--signal);
}

.density-toggle__glyph {
  font-family: var(--mono);
  font-size: var(--fs-sm);
  line-height: 1;
}
`, "",{"version":3,"sources":["webpack://./src/ui/TableToolbar/TableToolbar.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,WAAW;EACX,kBAAkB;EAClB,sCAAsC;EACtC,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,yBAAyB;AAC3B;;AAEA;;iEAEiE;AACjE;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,+BAA+B;EAC/B,8BAA8B;EAC9B,qBAAqB;EACrB,wBAAwB;EACxB,yBAAyB;EACzB,eAAe;EACf,YAAY;EACZ,wBAAwB;EACxB,YAAY;AACd;;AAEA;EACE,wBAAwB;EACxB,uBAAuB;EACvB,wBAAwB;EACxB,cAAc;AAChB;;AAEA;EACE,OAAO;EACP,SAAS;EACT,uBAAuB;EACvB,aAAa;EACb,aAAa;EACb,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,YAAY;AACd;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,OAAO;EACP,wBAAwB;EACxB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,wBAAwB;EACxB,0BAA0B;EAC1B,yBAAyB;EACzB,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;EAC5B,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,+BAA+B;EAC/B,8BAA8B;EAC9B,yBAAyB;EACzB,4BAA4B;EAC5B,qBAAqB;EACrB,eAAe;EACf,wBAAwB;EACxB;;;oBAGkB;AACpB;;AAEA;EACE,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;EAC3B,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;EACxB,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,WAAW;AACX;EACE,OAAO;AACT;;AAEA,yEAAyE;AACzE;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA,wEAAwE;AACxE;EACE,YAAY;EACZ,eAAe;EACf,+BAA+B;EAC/B,8BAA8B;EAC9B,0BAA0B;EAC1B,kBAAkB;EAClB,wBAAwB;EACxB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,qCAAqC;EACrC,mBAAmB;AACrB;;AAEA,mBAAmB;AACnB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,wBAAwB;EACxB,0BAA0B;EAC1B,yBAAyB;EACzB,sBAAsB;EACtB,wBAAwB;AAC1B;;AAEA;EACE,oBAAoB;EACpB,+BAA+B;EAC/B,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,SAAS;EACT,qCAAqC;EACrC,wBAAwB;EACxB,0BAA0B;EAC1B,yBAAyB;EACzB,sBAAsB;EACtB,wBAAwB;EACxB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR;;oBAEkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,yCAAyC;AAC3C;;AAEA;EACE,wBAAwB;EACxB,uBAAuB;EACvB,cAAc;AAChB","sourcesContent":[".table-toolbar {\n  position: sticky;\n  top: var(--lb-topbar-h, 52px);\n  z-index: 20;\n  padding: 14px 24px;\n  border-bottom: 1px solid var(--border);\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  background: var(--bg-alt);\n}\n\n/* Search input — 320px is the *preferred* width (flex-basis), but it shrinks\n   intrinsically when the toolbar is cramped (min-width:0), so the page never\n   overflows sideways on narrow viewports. No fixed breakpoint. */\n.table-toolbar__search {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  height: 28px;\n  padding: 0 10px;\n  border: 1px solid var(--border);\n  border-radius: var(--radius-1);\n  background: var(--bg);\n  color: var(--text-muted);\n  font-size: var(--fs-meta);\n  flex: 0 1 320px;\n  min-width: 0;\n  font-family: var(--sans);\n  cursor: text;\n}\n\n.table-toolbar__search-icon {\n  font-family: var(--mono);\n  font-size: var(--fs-ui);\n  color: var(--text-muted);\n  flex-shrink: 0;\n}\n\n.table-toolbar__search-input {\n  flex: 1;\n  border: 0;\n  background: transparent;\n  outline: none;\n  font: inherit;\n  color: var(--text);\n  padding: 0;\n  margin: 0;\n  min-width: 0;\n}\n.table-toolbar__search-input::placeholder {\n  color: var(--text-muted);\n}\n.table-toolbar__search-input::-webkit-search-cancel-button {\n  appearance: none;\n}\n\n.table-toolbar__search--active:focus-within {\n  border-color: var(--text-secondary);\n}\n\n.table-toolbar__search-placeholder {\n  flex: 1;\n  color: var(--text-muted);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.table-toolbar__search-kbd {\n  font-family: var(--mono);\n  font-size: var(--fs-micro);\n  background: var(--bg-alt);\n  border: 1px solid var(--border);\n  border-radius: 2px;\n  padding: 1px 4px;\n  color: var(--text-secondary);\n  flex-shrink: 0;\n}\n\n/* Filter chips */\n.table-toolbar__chips {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  flex-wrap: wrap;\n}\n\n.table-toolbar__chip {\n  height: 26px;\n  padding: 0 10px;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  border: 1px solid var(--border);\n  border-radius: var(--radius-1);\n  font-size: var(--fs-meta);\n  color: var(--text-secondary);\n  background: var(--bg);\n  cursor: pointer;\n  font-family: var(--sans);\n  transition:\n    background 120ms ease,\n    border-color 120ms ease,\n    color 120ms ease;\n}\n\n.table-toolbar__chip:focus-visible {\n  outline: none;\n  box-shadow: var(--focus-ring);\n}\n\n.table-toolbar__chip--active {\n  border-color: var(--signal);\n  background: var(--signal-soft);\n  color: var(--signal-deep);\n}\n\n.table-toolbar__chip-count {\n  font-family: var(--mono);\n  font-size: var(--fs-sm);\n  color: var(--text-muted);\n}\n\n.table-toolbar__chip--active .table-toolbar__chip-count {\n  color: var(--signal-deep);\n}\n\n/* Spacer */\n.table-toolbar__spacer {\n  flex: 1;\n}\n\n/* Right-side control cluster — the sort + filter buttons sit together. */\n.table-toolbar__controls {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n}\n\n/* Inline filter select (e.g. court filter on the tribunals directory) */\n.table-toolbar__select {\n  height: 32px;\n  padding: 0 10px;\n  border: 1px solid var(--border);\n  border-radius: var(--radius-0);\n  background: var(--surface);\n  color: var(--text);\n  font-family: var(--mono);\n  font-size: var(--fs-meta);\n  cursor: pointer;\n}\n\n.table-toolbar__select:focus-visible {\n  outline: 2px solid var(--signal-deep);\n  outline-offset: 1px;\n}\n\n/* Density toggle */\n.density-toggle {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.density-toggle__label {\n  font-family: var(--mono);\n  font-size: var(--fs-micro);\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n  color: var(--text-muted);\n}\n\n.density-toggle__buttons {\n  display: inline-flex;\n  border: 1px solid var(--border);\n  border-radius: var(--radius-1);\n  overflow: hidden;\n}\n\n.density-toggle__btn {\n  padding: 4px 10px;\n  background: var(--bg);\n  border: 0;\n  border-right: 1px solid var(--border);\n  font-family: var(--mono);\n  font-size: var(--fs-micro);\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n  color: var(--text-muted);\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  transition:\n    background 120ms ease,\n    color 120ms ease;\n}\n\n.density-toggle__btn:last-child {\n  border-right: 0;\n}\n\n.density-toggle__btn--active {\n  background: var(--ink-dark);\n  color: var(--cream);\n}\n\n.density-toggle__btn:focus-visible {\n  outline: none;\n  box-shadow: inset 0 0 0 2px var(--signal);\n}\n\n.density-toggle__glyph {\n  font-family: var(--mono);\n  font-size: var(--fs-sm);\n  line-height: 1;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
